const my_profile = {
  viewMyClubSeacretProfile: "Visualizza il profilo di My ClubSecret", // translated
  unverifiedEmail: "E-mail non verificata", // translated
  verifiedEmail: "E-mail verificata", // translated
  viewMoreDetails: "Visualizza ulteriori dettagli", // translated
  createdFrom: "Creato da", // translated
  createdTo: "Creato fino a", // translated
  selectStatus: "Seleziona stato...", // translated
  searchByTitle: "Cerca per titolo...", // translated
  pushNotifications: "Notifica Push", // translated 
  pushNotificationsDescription: "Ricevi notifiche del browser per aggiornamenti ed eventi importanti", // translated 
  pushNotificationsNotSupported: "Le notifiche push non sono supportate in questo browser", // translated 
  pushNotificationsDeniedMessage: "Il permesso di notifica è stato negato. Si prega di abilitare le notifiche nelle impostazioni del browser per ricevere notifiche push.", // translated 
  pushNotificationsEnabled: "Notifiche push abilitate con successo", // translated 
  pushNotificationsDisabled: "Notifiche push disabilitate con successo", // translated 
  userInformationMissing: "Le informazioni utente sono mancanti", // translated 
  failedToUpdatePushNotifications: "Impossibile aggiornare le impostazioni delle notifiche push", // translated 
  notificationPermissionDenied: "Il permesso di notifica è stato negato. Si prega di abilitarlo nelle impostazioni del browser.", // translated 
  notificationPermissionRequired: "Il permesso di notifica è richiesto per abilitare le notifiche push", // translated 
  notSupported: "Non guadagna", // translated 
  permissionDenied: "Permesso negato", // translated 
  permissionNotRequested: "Permesso non richiesto", // translated 
  enabled: "Abilitato", // translated 
  disabled: "Disabilitato", // translated 
};


export default my_profile;
